<template>
  <div class="my-message-container">
    <div class="work-content">
      <div class="panel-title">
        <div class="name">基本信息</div>
        <div class="desc">
          －
          编辑你的基本信息，将显示现舱大厅及其它必要页面中，并可以让更多的朋友了解和认识你！
        </div>
      </div>
      <el-form
        class="base-form mt20"
        :model="form"
        :rules="rules"
        ref="form"
        label-width="65px"
      >
        <el-row type="flex" align="middle">
          <el-col class="calc-2-60">
            <el-row type="flex" align="middle">
              <div class="photo">
                <img
                  class="photo-img"
                  :src="avatar?avatar:require('@/images/common/noAvatar.png')"
                />
              </div>
              <el-form-item class="ml30" prop="nickname" label="用户昵称">
                <el-input
                  placeholder="输入用户昵称"
                  v-model="form.nickname"
                  maxlength="50"
                  class="el-input--no-border"
                ></el-input>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row type="flex" class="mt16" align="middle">
          <el-col class="calc-2-60">
            <el-form-item prop="mobile" class='mobile-form-item'>
              <span slot="label">手机</span>
              <el-input
                class="el-input--no-border"
                placeholder="输入手机"
                v-model="form.mobile"
                disabled
                maxlength="30"
              ></el-input>
              <div class='no-modify-tip'>(不可修改）</div>
            </el-form-item>
          </el-col>
          <el-col class="calc-2-60">
            <el-form-item prop="email">
              <span slot="label">邮箱</span>
              <el-input
                class="el-input--no-border"
                placeholder="输入邮箱"
                v-model="form.email"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="mt16" align="middle">
          <el-col class="calc-2-60">
            <el-form-item prop="qq">
              <span slot="label">QQ</span>
              <el-input
                class="el-input--no-border"
                placeholder="输入QQ"
                v-model="form.qq"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col class="calc-2-60">
            <el-form-item prop="companyName">
              <span slot="label">公司名称 </span>
              <el-input
                placeholder="输入公司名称"
                v-model="form.companyName"
                maxlength="50"
                class="el-input--no-border"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row type="flex" align="middle" class="mt48">
        <el-button class="saveBtn" type="primary" :loading="loadingBasic" @click="saveClick"
          >保存修改</el-button
        >
      </el-row>
    </div>
    <div class="work-content mt20">
      <div class="panel-title">
        <div class="name">认证信息</div>
        <div class="desc">－ 编辑你的认证信息，就可以发布现舱/询盘了！</div>
      </div>
      <el-form
        class="base-form mt20"
        :model="authForm"
        :rules="authRules"
        ref="authForm"
        label-width="65px"
      >
        <el-row type="flex" class="mt16" align="middle">
          <el-col class="calc-2-60">
            <el-form-item prop="mobile" class='mobile-form-item'>
              <span slot="label">手机号码</span>
              <el-input
                class="el-input--no-border"
                placeholder="输入手机号码"
                v-model="authModel.mobileStar"
                maxlength="30"
                disabled
              ></el-input>
              <div class='no-modify-tip'>(不可修改）</div>
            </el-form-item>
          </el-col>
          <el-col class="calc-2-60">
            <el-form-item prop="nameCn">
              <span slot="label">真实姓名</span>
              <el-input
                class="el-input--no-border"
                placeholder="输入真实姓名"
                v-model="authForm.nameCn"
                :disabled="isAuthentication == 1"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="mt16" align="middle">
          <el-col class="calc-2-60">
            <el-form-item prop="identityCardNo">
              <span slot="label">身份证</span>
              <el-input
                class="el-input--no-border"
                placeholder="输入身份证号码"
                v-model="authForm.identityCardNo"
                :disabled="isAuthentication == 1"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row type="flex" align="middle" class="mt48" v-if="isAuthentication != 1">
        <el-button class="saveBtn" type="primary" :loading="loadingRealname" @click="authClick"
          >立即认证</el-button
        >
      </el-row>
    </div>
  </div>
</template>
<script>
import { wzmyMessageNew,wzupdateByPrimaryKey } from "@/api/workBench/myMessage";
import { certification } from "@/api/currentCabinHall/currentCabinHall";
import { mapState } from "vuex";
export default {
  name: "myMessage",
  data() {
    const validatorsFactory = () => {
      return new this.$CommonValidators(this);
    };
    const validatorsInstance = validatorsFactory();
    const commonValidators = validatorsInstance.validators();
    const pageValidators = {};
    const validators = {
      ...commonValidators,
      ...pageValidators,
    };

    return {
      avatar:'',//头像
      form: {
        nickname: "",
        mobile: "",
        email: "",
        qq: "",
        companyName: "",
      },
      loadingBasic:false,//基本信息
      loadingRealname:false,//实名信息
      // isAuthentication:'',//isAuthentication 1实名 2未实名
      rules: {
        nickname: [
          {
            required: true,
            validator: validators.notEmpty,
            trigger: "blur",
            messageCn: "请输入用户昵称",
            messageEn: "please input your english name",
          },
        ],
        mobile: [
          {
            required: true,
            validator: validators.chinaMobile,
            trigger: "blur",
            messageCn: "请输入手机",
            messageEn: "please input your english name",
          },
        ],
        email: [
          {
            required: true,
            validator: validators.email,
            trigger: "blur",
            messageCn: "请输入邮箱",
            messageEn: "please input your english name",
          },
        ],
        qq: [
          {
            required: true,
            validator: validators.notEmpty,
            trigger: "blur",
            messageCn: "请输入QQ号",
            messageEn: "please input your english name",
          },
        ],
        companyName: [
          {
            required: true,
            validator: validators.notEmpty,
            trigger: "blur",
            messageCn: "请输入公司名称",
            messageEn: "please input your english name",
          },
        ],
      },

      authForm: {
        mobile: "",
        nameCn: "",
        identityCardNo: "",
      },
      authModel: {
        mobileStar:''
      },
      authRules: {
        mobile: [
          {
            required: true,
            validator: validators.notEmpty,
            trigger: "blur",
            messageCn: "请输入手机号码",
            messageEn: "please input your english name",
          },
        ],
        nameCn: [
          {
            required: true,
            validator: validators.notEmpty,
            trigger: "blur",
            messageCn: "请输入真实姓名",
            messageEn: "please input your english name",
          },
          {
            required: true,
            validator: validators.isHanzi,
            trigger: "blur",
            messageCn: "真实姓名必须为中文",
            messageEn: "please input your english name",
          },
        ],
        identityCardNo: [
          {
            required: true,
            validator: validators.idCard,
            trigger: "blur",
            messageCn: "请输入身份证号码",
            messageEn: "please input your english name",
          },
        ],
      },
    };
  },
  components: {},
  watch: {},
  computed:{
    ...mapState("user", {
      mobile: (state) => state.mobile,
      isAuthentication: (state) => state.isAuthentication,
    }),
  },
  created() {
    // 详情
    this.wzmyMessageNew();
  },
  mounted() {
    // this.$nextTick(()=>{
    //   this.authForm.mobile = this.mobile;
    //   this.form.mobile = this.mobile;
    // })
  },
  methods: {
    // 信息
    async wzmyMessageNew() {
      // ==========接口调用==========
      let res;
      let params = {};
      this.loading = true;
      try {
        res = await wzmyMessageNew(params);
        // this.isAuthentication = res.isAuthentication;//实名认证判断
        // 认证
        let isAuthentication = res.isAuthentication;//1认证成功 2认证失败
        this.$store.dispatch("user/isAuthenticationMethods",isAuthentication);
        // 认证
        console.log('详情',res)
        this.form.nickname = res.nickname;
        this.form.mobile = res.mobile;
        this.form.email = res.email;
        this.form.qq = res.qq;
        this.form.companyName = res.companyName;
        this.avatar = res.headPic;
        //实名认证数据
        this.authForm.mobile =  res.mobile;
        this.authModel.mobileStar =  res.mobileStar;
        this.authForm.nameCn =  res.nameCn;
        this.authForm.identityCardNo =  res.identityCardNo;
      } catch (e) {
        console.error(e);
      }
    },
    // 修改信息
    async wzupdateByPrimaryKey() {
      // ==========接口调用==========
      let res;
      let params = {
        ...this.form
      };
      this.loadingBasic = true;
      try {
        res = await wzupdateByPrimaryKey(params);
        // console.log('修改信息',res)
        if(res.code == "1"){
          this.$message({ type: "success", message: "修改成功" });
        }else{
          this.$message({ type: "error", message: res.message });
        }
        this.loadingBasic = false;
      } catch (e) {
        this.loadingBasic = false;
        console.error(e);
      }
    },
    async saveClick() {
      this.isSubmit = true;
      let checkRes = await this.$checkForm(this.$refs.form, this.rules);
      this.isSubmit = false;
      if (checkRes) {
        return;
      }
      // 修改基本信息
      this.wzupdateByPrimaryKey();
    },
    // 认证
    async authClick() {
      this.isSubmit = true;
      let checkRes = await this.$checkForm(this.$refs.authForm, this.authRules);
      this.isSubmit = false;
      if (checkRes) {
        return;
      }
      this.certification();
    },
     // 实名认证
    async certification() {
      // ==========接口调用==========
      let res;
      let params = {
        ...this.authForm,
      };
      try {
        this.loadingRealname = true;
        res = await certification(params);
        if(res.code == 1){
          this.$message({ type: "success", message: "认证成功" });
          // 认证
          let isAuthentication = 1;//1认证成功 2认证失败
          this.$store.dispatch("user/isAuthenticationMethods",isAuthentication);
          // 认证
          this.wzmyMessageNew();
        }else{
          this.$message({ type: "error", message: res.message });
        }
        this.loadingRealname = false;
        // console.log("certification",res)
      } catch (e) {
        console.error(e);
        this.loadingRealname = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.my-message-container {
  @import "@/styles/variable.scss";
  // user-form样式覆盖
  /deep/ .base-form.el-form {
    @include el-form--bottom-vali(65px);
  }
  // 2等分，间距60px
  .calc-2-60 {
    width: calc((100% - 60px) / 2);
    margin-right: 60px;
    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .panel-title {
    display: flex;
    align-items: center;

    .name {
      font-size: 18px;
      font-weight: bold;
      color: #373842;
    }
    .desc {
      font-size: 14px;
      font-weight: 500;
      color: #727887;
    }
  }
  .base-form {
    .photo {
      width: 74px;
      height: 74px;
      overflow: hidden;
      border-radius: 50%;
      flex: 0 0 auto;
      .photo-img {
        display: block;
        width: 100%;
        height: auto;
      }
    }
  }
  .saveBtn {
    width: 104px;
    height: 34px;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
  }
  .mobile-form-item {
    position: relative;
    .no-modify-tip {
      position: absolute;
      color:#808795;
      font-size: 12px;
      top: 8px;
      left: 100px;
    }
  }
}
</style>